import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppRoutes from "./appRoutes";
import AppTheme from "./AppTheme";
import { LoaderProvider } from "../components";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import ltLocale from "date-fns/locale/lt";

export default function App() {
  return (
    <BrowserRouter>
      <AppTheme>
        <LocalizationProvider
          dateAdapter={AdapterDateFns}
          adapterLocale={ltLocale}
        >
          <LoaderProvider>
            <AppRoutes />
          </LoaderProvider>
        </LocalizationProvider>
      </AppTheme>
    </BrowserRouter>
  );
}
